import {bankCodes} from "src/config/banks"
import {bidBlocks} from "src/config/bidBlocks"
import {buildListRequisites} from "src/utils/bidRequisitesDisplay"

export const isDocumentNumberListDocument = (doc) => {
  if (!doc) {
    return false
  }
  if (doc?.document_template?.file_document_template?.document_type_name === "customer_template") {
    return true
  }
  if (doc?.file_document?.document_type_name === "empty_file_document_type") {
    return true
  }
  return false
}

export const getDocumentNumberListInline = (bid) => {
  const listDocuments = bid?.document_list?.filter(isDocumentNumberListDocument) ?? []

  if (listDocuments.length > 0) {
    const numbers = listDocuments
      .filter(i => i?.document_number?.length > 0)
      .map(l => l.document_number)
      .join(' | ')
    return numbers.length > 0 ? numbers : "-"
  }

  if (bid?.document_number_list?.length > 0) {
    return bid.document_number_list.map(l => l.document_number).join(' | ')
  }

  return null
}

const paymentErrorMap = [
  {
    match: 'custom_data.seller_data must include valid seller_payout_kind',
    text: 'Выплата возможна только самозанятому.',
  },
]

export const mapPaymentError = (error) => {
  if (!error || typeof error !== 'string') return error
  const mapped = paymentErrorMap.find(item => error.includes(item.match))
  return mapped ? mapped.text : error
}

export const getDataItem = (bid) => {

  const requisites = buildListRequisites(bid)
  let bank_name = null
  if (requisites.phone) {
    const r = bid.requisite_list.filter(req => req.is_active).find(r => r.requisite_type_name === 'phone')
    bank_name = bankCodes[r.bank_code] ?? null
  }

  const status = bid.is_approved === false && bid.status === 'new' ? 'on_review' : bid.status
  // bid.is_approved === true && bid.status === 'error' && bid.rejection_reason === 'Операция отклонена банком' ? 'error_rejected' : bid.status

  const wd_list = bid?.withdrawal_list ? bid.withdrawal_list.slice() : null;
  if (wd_list) {
    wd_list.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime())
  }
  const error_message = wd_list && (wd_list[0] && wd_list[0].withdrawal_request_status === 'rejected'
    && (status === 'error' || status === 'rejected')) ? wd_list[0].withdrawal_request_error_message : null;

  const editable = (bid.status === 'new' || bid.status === 'error') && bid.is_approved === true

  const passport = bid?.seller?.person_passport?.find(p => p.is_active)

  let first_name, last_name, middle_name

  if (passport) {
    first_name = passport?.first_name
    middle_name = passport?.middle_name
    last_name = passport?.last_name
  } else if (bid?.seller) {
    first_name = bid?.seller?.first_name
    middle_name = bid?.seller?.middle_name
    last_name = bid?.seller?.last_name
  }

  const car = bid?.car

  const beatufyName = (name) => {
    const name2 = name.toLowerCase()
    return name2.charAt(0).toUpperCase() + name2.slice(1)
  }

  const files = []

  if (bidBlocks?.auto?.display) {
    bid?.document_number_list
      .map(document => {
        if (document.scrap_class_name === 'Авто') {
          files.push(document.document_number)
        }
      })
  } else {
    bid?.document_number_list
      .map(document => {
        files.push(document.document_number)
      })
  }


  const documentNumberListInline = getDocumentNumberListInline(bid)

  const sellerFullName = ((first_name || middle_name || last_name) && bidBlocks.seller.display) ?
    `${last_name ? last_name + ' ' : ''}${first_name ? first_name + ' ' : ''}${middle_name ? middle_name : ''}`
    :
    '–'
  const sellerName = ((first_name || middle_name || last_name) && bidBlocks.seller.display) ?
    `${last_name && last_name != '-' ? beatufyName(last_name) + ' ' : ''}${first_name && first_name != '-' ? first_name[0].toUpperCase() + '.' : ''}${middle_name && middle_name != '-' ? middle_name[0].toUpperCase() + '.' : ''}`
    :
    '–'

  const receiverFulllName = ((requisites.first_name || requisites.middle_name || requisites.last_name)) ?
    `${requisites.last_name ? requisites.last_name + ' ' : ''}${requisites.first_name ? requisites.first_name + ' ' : ''}${requisites.middle_name ? requisites.middle_name : ''}`
    :
    null

  const receiverName = ((requisites.first_name || requisites.middle_name || requisites.last_name)) ?
    `${requisites.last_name && requisites.last_name != '-'
      ? beatufyName(requisites.last_name) + ' '
      : ''}${requisites.first_name && requisites.first_name != '-' ? requisites.first_name[0].toUpperCase() + '.' : ''}${requisites.middle_name && requisites.middle_name != '-' ? requisites.middle_name[0].toUpperCase() + '.' : ''}`
    :
    null

  const seller = (bid?.seller && bidBlocks.seller.display) ?
    bid.seller : null

  const validationError = bid?.validation_error

  const requisitesErrors = []
  const phoneErrors = []
  const priceErrors = []

  if (validationError?.card_number) {
    validationError?.card_number.forEach(error => {
      requisitesErrors.push(error)
    })
  }

  if (validationError?.bank_code) {
    validationError?.bank_code.forEach(error => {
      requisitesErrors.push(error)
    })
  }

  if (validationError?.requisite) {
    validationError?.requisite.forEach(error => {
      requisitesErrors.push(error)
    })
  }

  if (validationError?.price) {
    validationError?.price.forEach(error => {
      priceErrors.push(error)
    })
  }

  if (validationError?.phone_number) {
    validationError?.phone_number.forEach(error => {
      phoneErrors.push(error)
    })
  }

  return {
    files,
    sellerFullName,
    sellerName,
    receiverFulllName,
    receiverName,
    bankName: bank_name,
    status,
    requisites,
    seller,
    invalid: !bid?.is_valid,
    requisitesErrors,
    phoneErrors,
    priceErrors,
    car,
    documentNumberListInline
  }
}


export const getPanRequisiteId = (value, list, isPan) => {
  if (!isPan) {
    return
  }
  const found = list.find(item => item.label.replaceAll(' ', '') === value);

  if (found) {
    return found.value;
  }
};

export const getPhoneRequisiteId = (value, bankCode, list, preferredId) => {
  const phone = String(value ?? '').replace(/\D/g, '')
  if (!phone || !bankCode?.value) return

  const matches = item =>
    item.label.replace(/\D/g, '') === phone && item.bankCode === bankCode.value

  return list.find(item => item.value === preferredId && matches(item))?.value ??
    list.find(matches)?.value
}

export const isValidSellerRequisite = (value, list) => {
  return list.some(item => item.label === value);
}


export const getBidsStatusesParams = (statusesList = []) => {
  const statuses = []
  let isApproved

  if (statusesList.includes('pending')) {
    statuses.push('pending')
  }

  if (statusesList.includes('error')) {
    statuses.push('error')
  }

  if (statusesList.includes('rejected')) {
    statuses.push('rejected')
  }

  if (statusesList.includes('done')) {
    statuses.push('done')
  }

  if (statusesList.includes('new') || statusesList.includes('on_review')) {
    statuses.push('new')
  }

  if (statusesList.includes('new') && !statusesList.includes('on_review')) {
    isApproved = true
  }

  if (!statusesList.includes('new') && statusesList.includes('on_review')) {
    isApproved = false
  }

  return {
    statuses: statusesList.includes('all') ? undefined : statuses,
    isApproved
  }
}



export const getBidsStatusesDisabled = (statusesList) => {

  if (statusesList.includes('on_review')) {
    return ['pending', 'error', 'rejected', 'done']
  }

  if (
    statusesList.includes('pending') ||
    statusesList.includes('error') ||
    statusesList.includes('rejected') ||
    statusesList.includes('done')
  ) {
    return ['on_review',]
  }

  return []
}

export const normalizeSimilarBidsResponse = (data) => {
  if (Array.isArray(data)) {
    return data
  }
  if (data && typeof data === 'object' && data.id) {
    return [data]
  }
  return []
}
